const SET_NEW_MENU_NAME = 'SET_NEW_MENU_NAME';
const SET_NEW_MENU_DATES = 'SET_NEW_MENU_DATES';
const SET_NEW_MENU_ENTITIES = 'SET_NEW_MENU_ENTITIES';
const SET_NEW_MENU_MEALS = 'SET_NEW_MENU_MEALS';
const CREATE_NEW_MENU_REQUEST = 'CREATE_NEW_MENU_REQUEST';
const CREATE_NEW_MENU_SUCCESS = 'CREATE_NEW_MENU_SUCCESS';
const CREATE_NEW_MENU_FAILURE = 'CREATE_NEW_MENU_FAILURE';

export default {
  SET_NEW_MENU_NAME,
  SET_NEW_MENU_DATES,
  SET_NEW_MENU_ENTITIES,
  SET_NEW_MENU_MEALS,
  CREATE_NEW_MENU_REQUEST,
  CREATE_NEW_MENU_SUCCESS,
  CREATE_NEW_MENU_FAILURE
};
